export default __webpack_public_path__ + "static/media/con_ev01.c4ff1579.jpg";